import styled from 'styled-components'

export default styled.article`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;

  header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    flex: 0 0 auto;
    background-color: ${ ({ theme }) => theme.colors.white };
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
    z-index: 1;

    h3 {
      margin: 0;
      font-size: 16px;
      text-transform: uppercase;
      color: ${ ({ theme }) => theme.colors.primary };
    }

    .close-fullscreen-map {
      position: absolute;
      right: 16px;
      width: 14px;
      height: 14px;
      cursor: pointer;
    }
  }

  .map {
    position: relative;
    flex: 1;
  }
`
